import styles from './NewRecord.module.css';

export const NewRecord = ({ noiseLevel }) => {
  let textNoiseLevel = noiseLevel?.replaceAll('.', ',').split('');

  return (
    <div className={styles.record}>
      <span>новый рекорд:</span>
      <div className={styles.numRecord}>
        {textNoiseLevel.map((num, idx) => (
          <div key={idx} className={`${num === ',' ? styles.comma : ''}`}>
            {num}
          </div>
        ))}
      </div>
    </div>
  );
};
